import { Component, OnInit, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { TablerIconComponent } from "angular-tabler-icons";
import { filter } from "rxjs/operators";
import { BaseComponent } from "src/app/core/base/base.component";
import { MenuServiceParameterizationResponse } from "src/app/core/models/menu-service.model";
import { Order } from "src/app/core/models/order";
import { EventService } from "src/app/core/services/event.service";
import { OrderCheckService } from "src/app/core/services/order-check.service";
import { OrderService } from "src/app/core/services/order.service";
import { ThemeService } from "src/app/core/services/theme.service";
import { CustomCurrencyPipe } from "../../pipes/currency.pipe";
import { MenuConfigurationDialog } from "../dialogs/menu-configuration/menu-configuration.component";

@Component({
  selector: "app-footer",
  imports: [TablerIconComponent, RouterModule, CustomCurrencyPipe],
  templateUrl: "footer.component.html",
  styleUrls: ["footer.component.scss"],
})
export class FooterComponent extends BaseComponent implements OnInit {
  // Injections
  public orderCheckService = inject(OrderCheckService);
  private eventService = inject(EventService);
  private orderService = inject(OrderService);
  private router = inject(Router);
  readonly dialog = inject(MatDialog);
  private themeService = inject(ThemeService);

  // Variables
  parameterization: MenuServiceParameterizationResponse =
    this.orderCheckService.getParameterization();
  order: Order | null = null;
  selectedProductsCount = 0;
  showCartBar = true;
  categoryTitleColor = this.themeService.getSecondaryContrastTextColor();

  ngOnInit(): void {
    if (this.parameterization?.CompanyId) {
      this.order = this.orderService.getOrder(this.parameterization.CompanyId);
    }
    this.updateShowCartBar(this.router.url);
    this.onSubscribe();
  }

  onSubscribe() {
    this.subs.push(
      this.eventService.orderChanged$.subscribe((order: Order) => {
        this.order = order;
      }),
    );

    this.subs.push(
      this.eventService.selectedProductsCountChanged$.subscribe(
        (selectedProductsCount: number) => {
          this.selectedProductsCount = selectedProductsCount;
        },
      ),
    );

    this.subs.push(
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => this.updateShowCartBar(event.urlAfterRedirects)),
    );
  }

  private updateShowCartBar(url: string): void {
    this.showCartBar = !url.includes("/pedidos");
  }

  addSelectedProductsToCart() {
    this.eventService.publishAddSelectedProductsToCart();
  }

  clearSelectedProducts() {
    this.eventService.publishClearSelectedProducts();
  }

  //#region Dialog
  onOpenMenuConfigurationDialog() {
    this.dialog.open(MenuConfigurationDialog, {
      width: "100%",
      height: "100%",
      maxWidth: "100vw",
      maxHeight: "100vh",
      panelClass: "w-dialog",
      autoFocus: false,
    });
  }
}
